module.exports = __webpack_public_path__ + "app-static/img/null2.710e0070.png";